import React from 'react';

export const EmailSent = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12682_1261482)">
      <path
        d="M16.666 9.58398V5.83398C16.666 5.61297 16.5782 5.40107 16.4219 5.24479C16.2656 5.08851 16.0537 5.00065 15.8327 5.00065H4.16602C3.945 5.00065 3.7331 5.08851 3.57682 5.24479C3.42054 5.40107 3.33268 5.61297 3.33268 5.83398V14.1673C3.33268 14.3883 3.42054 14.6002 3.57682 14.7565C3.7331 14.9128 3.945 15.0007 4.16602 15.0007H9.99935C10.4596 15.0007 10.8327 15.3737 10.8327 15.834C10.8327 16.2942 10.4596 16.6673 9.99935 16.6673H4.16602C3.50297 16.6673 2.86728 16.4037 2.39844 15.9349C1.9296 15.4661 1.66602 14.8304 1.66602 14.1673V5.83398C1.66602 5.17094 1.9296 4.53525 2.39844 4.06641C2.86728 3.59757 3.50297 3.33398 4.16602 3.33398H15.8327C16.4957 3.33398 17.1314 3.59757 17.6003 4.06641C18.0691 4.53525 18.3327 5.17094 18.3327 5.83398V9.58398C18.3327 10.0442 17.9596 10.4173 17.4993 10.4173C17.0391 10.4173 16.666 10.0442 16.666 9.58398Z"
        fill="#3B82F6"
      />
      <path
        d="M15 17.4993V12.4993C15 12.0391 15.3731 11.666 15.8333 11.666C16.2936 11.666 16.6667 12.0391 16.6667 12.4993V17.4993C16.6667 17.9596 16.2936 18.3327 15.8333 18.3327C15.3731 18.3327 15 17.9596 15 17.4993Z"
        fill="#3B82F6"
      />
      <path
        d="M15.3076 11.853C15.6349 11.586 16.1174 11.6049 16.4225 11.91L18.9225 14.41C19.2479 14.7354 19.2479 15.2629 18.9225 15.5883C18.597 15.9138 18.0695 15.9138 17.7441 15.5883L15.8333 13.6775L13.9225 15.5883C13.597 15.9138 13.0695 15.9138 12.7441 15.5883C12.4186 15.2629 12.4186 14.7354 12.7441 14.41L15.2441 11.91L15.3076 11.853Z"
        fill="#3B82F6"
      />
      <path
        d="M17.0372 5.14005C17.4201 4.88475 17.9375 4.98823 18.1928 5.37117C18.4481 5.75411 18.3446 6.27147 17.9617 6.52677L10.4617 11.5268C10.1817 11.7134 9.8171 11.7134 9.53718 11.5268L2.03718 6.52677C1.65424 6.27147 1.55077 5.75411 1.80606 5.37117C2.06136 4.98823 2.57872 4.88475 2.96166 5.14005L9.99942 9.83162L17.0372 5.14005Z"
        fill="#3B82F6"
      />
    </g>
    <defs>
      <clipPath id="clip0_12682_1261482">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
